const API_BASE_URL = 'https://api.dev.auxo.dk';

const ALIAS_MAP = {
  'index': 'index',
  'forside': 'index',
  'home': 'index',
  'vognmand': 'vognmand',
  'vognmandskoersel': 'vognmand',
  'vognmand-i-skals-viborg-skive-omegn': 'vognmand',
  'grus-og-sten': 'grus-og-sten',
  'sand-grus-og-sten': 'grus-og-sten',
  'sand-og-grus': 'grus-og-sten',
  'sand-grus-og-sten-i-skals-viborg-skive-resten-af-danmark': 'grus-og-sten',
  'containerudlejning': 'containerkoersel',
  'containerkoersel': 'containerkoersel',
  'containerkørsel': 'containerkoersel',
  'containerservice': 'containerkoersel',
  'containerudlejning-i-skals-viborg-skive-omegn-leje-af-container': 'containerkoersel',
  'krankoersel': 'krankoersel',
  'krankoersel-i-viborg-skals-skive-omegn-private-erhverv': 'krankoersel',
  'vognmand-til-krankoersel-i-viborg-skals-vognmandsforretning': 'index',
  'udlejning-af-maskiner': 'udlejning-af-maskiner',
  'udlejning-af-smaa-maskiner': 'udlejning-af-maskiner',
  'udlejning-af-smaa-maskiner-i-skals-viborg-skive-omegn': 'udlejning-af-maskiner',
  'maskinudlejning': 'udlejning-af-maskiner',
  'arbejde-med-gummiged': 'arbejde-med-gummiged',
  'arbejde-med-gummiged-skals-vognmandsforretning': 'arbejde-med-gummiged',
  'gummiged': 'arbejde-med-gummiged',
  'haveflis': 'haveflis',
  'haveflis-og-traeflis': 'haveflis',
  'haveflis-skals-vognmandsforretning': 'haveflis',
  'profil': 'profil',
  'om-os': 'profil',
  'profil-skals-vognmandsforretning': 'profil',
  'vores-lastbiler': 'vores-lastbiler',
  'lastbiler': 'vores-lastbiler',
  'vores-lastbiler-skals-vognmandsforretning': 'vores-lastbiler',
  'kontakt': 'kontakt',
  'kontakt-os': 'kontakt',
  'kontakt-skals-vognmandsforretning': 'kontakt'
};

export function resolveCanonicalSlug(slug) {
  if (!slug) return 'index';
  const cleanSlug = String(slug).toLowerCase().trim().replace(/^\/+|\/+$/g, '');
  return ALIAS_MAP[cleanSlug] || cleanSlug;
}

export async function fetchCMSCollection(collectionName) {
  try {
    const response = await fetch(`${API_BASE_URL}/public/content/${collectionName}`);
    if (!response.ok) {
      throw new Error(`Kunne ikke hente collection: ${collectionName}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Fejl ved hentning af ${collectionName}:`, error);
    return [];
  }
}

export async function getPages() {
  return fetchCMSCollection('pages');
}

export async function getPageBySlug(rawSlug) {
  const pages = await getPages();
  const canonical = resolveCanonicalSlug(rawSlug);

  // 1. Try exact match on page_slug with canonical
  let page = pages.find(p => p.page_slug === canonical);
  if (page) return page;

  // 2. Try match on rawSlug against page_slug or CMS slug
  page = pages.find(p => 
    p.page_slug === rawSlug || 
    (p.slug && typeof p.slug === 'object' && p.slug._ === rawSlug) ||
    p.slug === rawSlug
  );
  if (page) return page;

  // 3. Fallback match on CMS slug object
  return pages.find(p => {
    const cmsSlug = p.slug && typeof p.slug === 'object' ? p.slug._ : p.slug;
    return cmsSlug && resolveCanonicalSlug(cmsSlug) === canonical;
  }) || null;
}

export async function getGalleryImages(rawSlug) {
  const canonical = resolveCanonicalSlug(rawSlug);
  const images = await fetchCMSCollection('gallery_images');
  return images
    .filter(img => img.page_slug === canonical || img.page_slug === rawSlug)
    .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
}

export async function getMenuItems() {
  const items = await fetchCMSCollection('menu_items');
  return items.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
}
